import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_SFU_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default client;
